<div style="display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin-bottom: 2rem; margin-top: 1rem">
  <button (click)="openCreateCourseDialog()" color="primary"
          mat-raised-button>{{ 'Create Course' | translate }}</button>

  <mat-form-field appearance="outline" style="margin-bottom: -1.25em">
    <mat-label>{{'Sort by Date' | translate}}</mat-label>
    <mat-select (selectionChange)="onSortDirectionChange($event.value)" [value]="sortDirection">
      <mat-option value="desc">{{'Newest First' | translate}}</mat-option>
      <mat-option value="asc">{{'Oldest First' | translate}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<table [dataSource]="courses" class="mat-elevation-z8" mat-table>
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell> {{ 'Course Name' | translate }}</th>
    <td *matCellDef="let course" mat-cell> {{course.name}} </td>
  </ng-container>

  <ng-container matColumnDef="startDateOfApplication">
    <th *matHeaderCellDef mat-header-cell> {{ 'Application Start Date' | translate }}</th>
    <td *matCellDef="let course" mat-cell> {{course.startDateOfApplication | date:'dd/MM/yyyy'}} </td>
  </ng-container>

  <ng-container matColumnDef="endDateOfApplication">
    <th *matHeaderCellDef mat-header-cell> {{ 'Application End Date' | translate }}</th>
    <td *matCellDef="let course" mat-cell> {{course.endDateOfApplication | date:'dd/MM/yyyy'}} </td>
  </ng-container>

  <ng-container matColumnDef="edit">
    <th *matHeaderCellDef mat-header-cell> {{ 'Edit' | translate }} </th>
    <td *matCellDef="let course" mat-cell>
      <a (click)="openEditCourseDialog(course)"
         style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
        <i class="fa fa-edit"></i>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="remove">
    <th *matHeaderCellDef mat-header-cell> {{ 'Remove' | translate }} </th>
    <td *matCellDef="let course" mat-cell>
      <a (click)="deleteCourse(course.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
        <i class="fa fa-remove"></i>
      </a>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
</table>
